import { SVGAttributes } from "react";

export const RunwayIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" }
) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 4a1 1 0 010-2h4.833c.454 0 1.065.102 1.697.418 1.109.554 1.803 1.595 1.803 3.082 0 1.487-.694 2.528-1.803 3.082A3.859 3.859 0 019.833 9H5a1 1 0 010-2h4.833c.171 0 .498-.054.803-.207.454-.227.697-.592.697-1.293 0-.7-.244-1.066-.697-1.293A1.982 1.982 0 009.833 4H5z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.656 8L12 13 9.656 8z"
        fill="currentColor"
      />
      <path
        d="M8.75 8.424a1 1 0 111.812-.848l2.344 5a1 1 0 01-1.811.848l-2.344-5zM4 3a1 1 0 012 0v10a1 1 0 11-2 0V3z"
        fill="currentColor"
      />
    </svg>
  );
};
RunwayIcon.displayName = "RunwayIcon";
